<template>
  <div>
    <div class="text-xl font-black py-2">12. Agree actions and objectives</div>

    <div class="pt-4 px-2 w-full">
      <div class="text-lg font-black">Action Points</div>
      <div>Please discuss and write down any agreed action points along with who will follow it up:</div>
      <div v-if="additionalActions && additionalActions.length">
        <div v-for="(item, index) in this.additionalActions" :key="index" class="pt-4 flex">
          <textarea class="w-3/4 py-2 px-3 border-2 rounded bg-white outline-none focus:border-primary-500 border-gray-300 hover:border-gray-400" v-model="additionalActions[index].value" :ref="'action'+index" :rows="2" :id="'action'+index" />
          <div class="flex w-1/4 items-center justify-between">
            <div class="pr-4 flex items-center">
              <input type="radio"  :id="page+'_agent_'+index" :name="page+'_action_'+index" value="agent" v-model="item.follow_by" style="width:50px; height: 20px;">
              <label :for="page+'_agent_'+index" class="ml-4 mt-2">Agent</label>
            </div>
            <div class="pr-4 flex items-center">
              <input type="radio"  :id="page+'_guild_'+index" :name="page+'_action_'+index" value="guild" v-model="item.follow_by" style="width:50px; height: 20px;">
              <label :for="page+'_guild_'+index" class="ml-4 mt-2">Guild</label>
            </div>
            <i class="fas fa-trash mr-4 cursor-pointer" @click="removeAction(index)" title="Remove this additional action"></i>
          </div>
        </div>
      </div>
      <div v-if="(!actions || !actions.length) && (!additionalActions || !additionalActions.length)" class="py-4" >
        No action added yet. Please click the add button to add a new action point.
      </div>
    </div>

    <div class="pt-4">
      <div class="text-green text-lg cursor-pointer" @click="addActions">+ Add an action point</div>
    </div>

    <div class="px-2 my-4 bg-gray-200 border rounded ">
      <div class="pt-4 px-2">
        <div class="text-lg font-black py-2">Schedule your next meeting</div>
        <date-picker-input
          label="Put a date in your diary for the next meeting (suggested within the next 3 months), even if it is preliminary, it is important to have the time scheduled."
          v-model="review.next_open_at"
          :min-date="review.open_at ? review.open_at.split(' ')[0] : 0"
          placeholder="Please Select"
          clear-button
        ></date-picker-input>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
import { v2Api } from '@/http'
import ErrorBag from '@/ErrorBag'
import { mapState } from 'vuex'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value,
      newNum: 0,
      actions: [],
      additionalActions: this.review.additionalActions,
      errorBag: new ErrorBag()
    }
  },
  computed: {
    ...mapState(['annualReview'])
  },
  watch: {
    'review.next_open_at' () {
      v2Api.post(`/annual-reviews/${this.annualReview.id}/update-next-open-at`,
        {
          'next_open_at': this.review.next_open_at
        }).then(
        response => {
        },
        errors => {
          this.errorBag.store(errors.response.data)
        })
    }
  },
  methods: {
    addActions () {
      this.additionalActions.push({ 'value': '' })
    },
    removeAction (index) {
      this.additionalActions.splice(index, 1)
    }
  }
}
</script>
